import React from "react";
import './MenuCategory.css';

import { Category, Heading, PageTitle } from "../../../components";
import { menu } from "../../../constants";
import { getMenuCategories } from "../../../utils";



const MenuCategory = () => {

  // Get the formatted categories from menu
  const categories = getMenuCategories(menu);

  return (
    <>
      {/* Page title */}
      <PageTitle title={'Menu Categories'} page={'Menu Categories'} />

      <section className="menu-categories">

        {/* Section Heading */}
        <Heading title={'Explore Our Menu Selections'} subTitle={'Menu Categories'} />

        {/* Category Items */}
        <div className="box-container">

          {categories.map(({ index, category, image }) => (
            <Category
              key={index}
              index={index}
              category={category}
              image={image}
            />
          ))}

        </div>

      </section>
    </>
  );
};

export default MenuCategory;